import { WhoDrugRecodePanel } from "../../whodrug/components/WhoDrugRecodePanel";
import { useWhoDrugRecode } from "../../whodrug/hooks/useWhoDrugRecode";
import { Badge } from "@/components/ui/badge";
import { RecordTable, type RecordTableProps } from "../../shared/components/record_review/RecordTable";
import { INTAKE_CODED_INDICATION_LABEL } from "../../shared/constants/caseReviewLabels";
import { useProductCodedIndication } from "../hooks/useProductCodedIndication";
import { useProductCodingSource } from "../hooks/useProductCodingSource";

/** Product-specific metadata stays beside the existing record selector and review table. */
export function ProductRecordReview(props: RecordTableProps) {
  const source = useProductCodingSource(props.api, props.sectionContext);
  const codedIndication = useProductCodedIndication(props.api, props.sectionContext);
  const coding = useWhoDrugRecode(props.api, props.sectionContext, props.activeGroup);
  const heading = <div className="cr-coding-source flex-wrap" aria-label="Product information">
    <div className="flex flex-wrap items-center gap-2">
    {source && <><span className="cr-coding-source-label">Coding source</span>
      <Badge variant="secondary">{source}</Badge></>}
    {codedIndication && <span>{INTAKE_CODED_INDICATION_LABEL}: {codedIndication}</span>}
    </div>
    <div className="ml-auto"><WhoDrugRecodePanel coding={coding} /></div>
  </div>;
  return <RecordTable {...props} recordHeader={heading} />;
}
